export default __webpack_public_path__ + "150982b1c95664dfd2d6a79a5492d044.png";